import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';

import SentimentColor from 'components/design/SentimentColor';
import { Cluster, ForceGraphResponse, Node } from "./ForceGraph";

interface ForceGraphTooltipProps {
  cluster: Cluster;
  node: Node;
  graph: ForceGraphResponse;
}

// Tooltip content component
export default function ForceGraphTooltip(props: ForceGraphTooltipProps): JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { cluster, node, graph }: ForceGraphTooltipProps = props;

  const colorArray = theme.colors.namedColors.chartColorArray;
  const clusterColor = colorArray[node.c % colorArray.length];

  return (
    <Box>
      <Typography sx={{mb: 1}} variant="h4">
        <Box
          sx={{
            width: 14,
            height: 14,
            backgroundColor:clusterColor,
            display:"inline-block",
            mr: 1,
            borderRadius: "3px"
          }} />
        {cluster.label}
      </Typography>
      <Typography>
        {i18n.t("positivity")}: 
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          <SentimentColor positivity={cluster.positivity}>
            {(cluster.positivity * 100).toFixed(1)}%
          </SentimentColor>
        </Box>
      </Typography>
      <Typography>
        {graph.count_is_exact && "Est."} 
        {i18n.t("record-count")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {cluster.count}
        </Box>
      </Typography>
      <Typography>
        {i18n.t("distribution")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {(cluster.distribution * 100).toFixed(4)}%
        </Box>
      </Typography>
    </Box>
  );
};
